export { default as tips } from './tips';